import img from '../../helpers/img';

export default {
  title: 'Audi USA',
  tile: {
    grid: 'col-12',
    bgImage: img('audi/audi-hero.jpg')
  },
  hero: {
    bgPosition: 'center',
    bgImage: img('audi/audi-hero.jpg')
  },
  info: {
    client: 'Audi USA (via AKQA)',
    timeline: 'Feb 2016 - current',
    description: [
      'AudiUSA.com is an enterprise CMS platform that caters to millions of visitors on a daily basis.',
      'I was contracted by AKQA to build front-end web components, including:',
      '::a native HTML5 video player',
      '::a filterable masonry list',
      '::various forms and modals'
    ],
    tools: `
      AEM,
      HTML (JSP),
      SASS,
      JS (CoffeeScript),
      NPM,
      Node,
      Grunt,
      Bower,
      Vagrant,
      Mocha,
      Teaspoon,
      Sinon
    `,
    buttons: [{
      text: 'VIEW WEBSITE',
      url: 'http://www.audiusa.com'
    }]
  },
  assets: [
    {
      grid: 'col-12 lap-6 desk-12',
      thumb: img('audi/audi-hero.jpg'),
      caption: 'Audi USA Hero'
    },
    {
      grid: 'col-12 mob-l-6 tab-12 lap-6',
      thumb: img('audi/myaudi-signin.jpg'),
      caption: 'myAudi Signin'
    },
    {
      grid: 'col-12 mob-l-6 tab-12 lap-6',
      thumb: img('audi/myaudi-dashboard.jpg'),
      caption: 'myAudi Dashboard'
    },
    {
      grid: 'col-12 mob-l-6 tab-12 lap-6',
      thumb: img('audi/myaudi-dealer-schedule.jpg'),
      caption: 'myAudi Dealer Service Schedule'
    },
    {
      grid: 'col-12 mob-l-6 tab-12 lap-6',
      thumb: img('audi/myaudi-profile.jpg'),
      caption: 'myAudi Profile Page'
    }
  ]
};



// WEBPACK FOOTER //
// ./src/fixtures/projects/audi.js